module.exports = __webpack_public_path__ + "img/antes_despues_318.422e4843.png";